import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// Self-hosted fonts (no third-party requests to Google Fonts).
import "@fontsource-variable/inter";
import "@fontsource-variable/source-serif-4";
import App from "./App";
import "./index.css";

const basename = import.meta.env.BASE_URL.replace(/\/$/, "") || "/";

createRoot(document.getElementById("root")!).render(
  <BrowserRouter basename={basename}>
    <App />
  </BrowserRouter>,
);
